// store/store.js
import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../features/authSlice';

const Store = configureStore({
  reducer: {
    auth: authReducer,
  },
});

export default Store;
